import type { ThemeConfig } from "../types";
import { RainbowRoadScene } from "./Scene";

export const rainbowRoad: ThemeConfig = {
  id: "rainbow-road",
  name: "Rainbow Road",
  tagline: "S-curve highway, candy hills, traveling pulses",
  brandLabel: "Rainbow Road",
  tokens: {
    bg: "#08001a",
    bgElevated: "rgba(255, 255, 255, 0.04)",
    bgPanel: "rgba(15, 5, 35, 0.9)",
    bgOverlay: "rgba(5, 0, 20, 0.85)",

    fg: "#ffffff",
    fgMuted: "rgba(240, 234, 255, 0.55)",
    fgStrong: "#f0eaff",
    fgInverse: "#0a0a0a",

    accent: "#ff4fd8",
    accentSoft: "rgba(255, 79, 216, 0.15)",
    accent2: "#ffd700",
    accent2Soft: "rgba(255, 215, 0, 0.18)",
    accentRainbow:
      "linear-gradient(90deg, #ff4fd8, #ff8c00, #ffd700, #c8ff00, #00e5ff, #c044ff, #ff4fd8)",

    border: "rgba(255, 79, 216, 0.22)",
    borderSoft: "rgba(255, 255, 255, 0.08)",
    borderStrong: "rgba(255, 79, 216, 0.5)",

    positive: "#00e5a0",
    negative: "#ff3a6e",
    warning: "#ff8c00",

    bankPanelBg:
      "linear-gradient(180deg, rgba(120, 0, 60, 0.97) 0%, rgba(100, 0, 180, 0.96) 30%, rgba(40, 0, 160, 0.96) 65%, rgba(0, 60, 140, 0.95) 100%)",
    bankPanelBorder: "rgba(192, 68, 255, 0.4)",
    bankPanelHeading: "#ff4fd8",

    fontDisplay: "'Barlow Condensed', 'Inter', system-ui, sans-serif",
    fontBody: "'Barlow', 'Inter', system-ui, sans-serif",
    fontMono: "'DM Mono', 'Menlo', ui-monospace, monospace",

    decorationGlow: "0 0 22px rgba(255, 79, 216, 0.45)"
  },
  assets: {
    mascot: "scene:rainbow-road",
    decorations: [],
    Scene: RainbowRoadScene
  }
};
